<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="'ADMIN_LEARNING_MODULES.BREADCRUMB_NAME' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="learning-modules">
  <div class="white-wrapper">
    <div class="learning-modules__header">
      <ion-item class="learning-modules__header__search" [formGroup]="form">
        <ion-input formControlName="search" [placeholder]="'BUTTONS.SEARCH' | translate"></ion-input>
      </ion-item>
      <div class="learning-modules__header">
        <ion-icon class="learning-modules__ellipsis" slot="icon-only" name="ellipsis-vertical" (click)="presentPopover($event)"></ion-icon>
      </div>
    </div>

    <ion-list class="learning-modules__list">
      <ion-item
        *ngFor="let module of learningModules$ | async | filterLearningModules:form.value.search; trackBy: trackBy"
        class="learning-modules__list__item"
        [class.--is-disabled]="!module.visible"
        detail="false"
        [routerLink]="[module.id]"
      >
        <div class="learning-modules__list__item__wrapper">
          <ion-img
            class="learning-modules__list__item__avatar"
            [style.backgroud]="'https://via.placeholder.com/150/F2F2F2'"
            [src]="module | learningModulesDefaultImage"
            [alt]="module.name"
          ></ion-img>
          <div class="learning-modules__list__item__detail">
            <span class="learning-modules__list__item__detail__name" [innerHTML]="module.name"></span>
            <span class="learning-modules__list__item__detail__description" [innerHTML]="module.id"></span>
          </div>
        </div>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
